import React, { memo, useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import RecoverPasswordForm from './RecoverPasswordForm';
import { Trans, useTranslation } from 'react-i18next';
import { Button } from 'antd';
import ForgotPassword from '../../services/Frogot.api.service';
import PageLayout from '../../components/PageLayout';

const pageInfo = {
  default: {
    title: 'recovery.title',
    subtext: 'recovery.subtext',
  },
  sent: {
    title: 'recovery.sentTitle',
    subtext: 'recovery.sentSubtext',
  }
};

function RecoverPassword ({ onLogin, ...rest}) {
  const { t } = useTranslation('authentication');
  const [sent, setSent] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = useCallback((formData) => {
    setLoading(true);
    setError('');
    ForgotPassword.init(formData).then(() => {
      setLoading(false);
      setSent(formData.identifier);
    }).catch((err) => {
      setLoading(false);
      setError(err?.response?.data?.message || 'Network error');
    });
  }, []);

  const pageProps = sent ? pageInfo.sent : pageInfo.default;
  if (sent)
    pageProps.subtext = <Trans i18nKey="authentication:recovery.sentSubtext" values={{ email: sent }}
      components={{ brake: <p className={'mb-4'}/>, bold: <strong/> }}/>;

  return (
    <PageLayout {...pageProps} error={error} onBack={onLogin}>
      {!sent ?
        <RecoverPasswordForm onSent={handleSubmit} loading={loading} {...rest}/>
        :
        <Button loading={loading} disabled={loading} className={'w-full'}
          size={'large'}
          onClick={() => setSent('')}
          type={'primary'}
        >
          {t('recovery.newLink')}
        </Button>
      }
    </PageLayout>
  );
}

export default memo(RecoverPassword);

RecoverPassword.propTypes = {
  onLogin: PropTypes.func,
  onSend: PropTypes.func
};
